import SalesOrderDocumentPage from "../../pages/legacy/SalesOrderDocumentPage";

const route = {
  key: "salesorder",
  path: "/legacy/sales-orders",
  component: SalesOrderDocumentPage,
  private: true,
  layout: "main",
  icon: "faFileInvoice",
  group: "sales",
  order: 21,
  permission: "legacy.salesorder.read"
};

export default route;